import { render, staticRenderFns } from "./PosInvoicesTaxRefundPdf.vue?vue&type=template&id=f2f5085e&scoped=true&"
import script from "./PosInvoicesTaxRefundPdf.vue?vue&type=script&lang=js&"
export * from "./PosInvoicesTaxRefundPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f5085e",
  null
  
)

export default component.exports